<template>
<el-form :inline="true" ref="goodform" enctype="multipart/form-data" :model="goodform" :rules="rules"  class="demo-form-inline jiaoyan" label-width="90px" size="mini">
    <el-drawer title="修改运单" @close="closeDialog"  direction="ltr" size="50%"  :visible="editFlag">
      <div style="padding:12px" class="inpBox">
         <el-form-item label="结算客户 :" prop="payee"  >
          <div v-if="tWayBusiness.payeeType==1">
            <el-select  v-model="goodform.payee" filterable placeholder="请选择" @change="jiesuanChange">
              <el-option v-for="item in kehuList" :label="item.customerName" :value="item.customerName" :key="item.id"></el-option>
            </el-select>
          </div>
          <div  v-else>
             <span>{{goodform.payee}}</span>
          </div>
         </el-form-item>
         <el-form-item label="项目名称:" prop="projectType"   >
          <el-select  v-model="goodform.projectType" filterable  placeholder="请选择">
            <el-option v-for="item in XMlist" :label="item.showName" :value="item.showName" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="业务类型:" prop="wayBusinessType"   >
          <el-select  v-model="goodform.wayBusinessType"  placeholder="请选择">
            <el-option v-for="item in YWLXlist" :label="item.showName" :value="item.itemNo" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="销售合同:"  >
          <el-input  placeholder="" class="disabled" :readonly="true"    maxlength="50" v-model="goodform.salesContract"  ></el-input>
        </el-form-item>
        <el-button type="text"  @click="xuanzeHT" style="margin-top: 8px;">选择</el-button>
        <el-form-item label="外部单号:"  >
          <el-input  placeholder=""    maxlength="50" v-model="goodform.externalOrderNumber"  ></el-input>
        </el-form-item>
        <el-form-item label="业务部门:" prop="insuranceInfo"   >
          <div style="width:150px">{{goodform.businessUnit}}</div>
        </el-form-item>
         <el-form-item label="业务人员:" prop="insuranceInfo"  v-if="isZhuanbao" >
          <div style="width:150px">{{goodform.businessUser}}</div>
        </el-form-item>
        <el-form-item label="业务人员:" prop="businessUserId" v-if="!isZhuanbao">
          <div v-if="ywyhFlag">{{goodform.businessUser}}</div>
          <el-select  v-else v-model="goodform.businessUserId" filterable placeholder="请选择" @change="yonghuChange">
            <el-option v-for="item in yonghuList" :label="item.userName" :value="item.userCode" :key="item.id"></el-option>
          </el-select>
        </el-form-item>
        <hr>
        <!-- 地址组件 -->
        <addDizhi :goodform="goodform" v-if="editFlag" ></addDizhi>
        <hr>
        <!-- 添加货物外库 -->
        <addGoodWay :goodform="goodform" v-if="editFlag" :glhwFlag="glhwFlag"></addGoodWay>
        <div class="addressBox" style="margin-top:20px">
         <h4 class="title">
            <span><i class="fa fa-bookmark iconFont" aria-hidden="true"></i>运输要求</span>
          </h4>
          <el-form-item label="要求到达时间:" prop="arrivalTime" label-width="120px">
              <el-date-picker
                v-model="goodform.arrivalTime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="timestamp"
                type="datetime"
                  placeholder="选择日期时间"
                  :picker-options="pickerOptions"
              ></el-date-picker>
          </el-form-item>
          <el-form-item label="回单要求:" prop="receiptRequest"   >
            <el-select  v-model="goodform.receiptRequest"  placeholder="请选择">
              <el-option  label="纸质回单" value="纸质回单" ></el-option>
              <el-option  label="电子回单" value="电子回单" ></el-option>
              <el-option  label="否" value="否" ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="需求车长:"   >
            <el-select  v-model="goodform.needLength" filterable placeholder="请选择">
              <el-option v-for="item in CClist" :label="item.name+'米'" :value="item.name+'米'" :key="item.id"></el-option>
            </el-select>
          </el-form-item>
          <br>
          <el-form-item label="提货到场时间:" label-width="120px">
              <el-date-picker
                v-model="goodform.pickupTime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="timestamp"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="提货紧急程度:" label-width="120px">
            <el-radio-group v-model="goodform.urgencyFlag"    >
              <el-radio :label="0">正常</el-radio>
              <el-radio :label="1">紧急</el-radio>
              <el-radio :label="2">加急</el-radio>
            </el-radio-group>
          </el-form-item>
          <br>
          <div>
            <el-tag style="margin:10px 10px;cursor: pointer;" v-for="item in elTags"
              :key="item"   @click="tagClick(item)" effect="plain">
              {{ item}}
            </el-tag>
          </div>
          <el-form-item label="" class="remark" prop="remark" label-width="0px">
            <el-input  placeholder="" :rows="2"  maxlength="500" v-model="goodform.remark"></el-input>
          </el-form-item>
        </div>
        <shouruWay :goodform="goodform" :isedite="true" v-if="!isZhuanbao"></shouruWay>
        <shouruWayZB :goodform="goodform"  v-if="isZhuanbao"></shouruWayZB>
        <hr>
        <uploadFiles :fileArr.sync='fileArr' :max=10  @remove="remove"></uploadFiles>
      </div>
      <el-drawer title="配载" size="98%" @close="closeDialog"   class="rightDrawer"
      :modal-append-to-body="false" :modal="false"  :visible="editFlag">
        <div  style="padding:12px">
           <!-- 车辆信息组件 -->
          <cheliangxinxi :goodform="goodform"  ></cheliangxinxi>
          <zhichu2wayxg :goodform="goodform" v-if="editFlag" ></zhichu2wayxg>
        <div class="footerBtn">
          <el-button  @click="closeDialog"  >取消</el-button>
          <el-button  type="primary"  @click="saveFn()">提 交</el-button>
        </div>
        </div>
      </el-drawer>
  </el-drawer>
  <!-- 关联合同 -->
  <guanlianhetong :goodform="goodform" v-if="GLHTflag" :GLHTflag.sync='GLHTflag'></guanlianhetong>
</el-form>
</template>

<script>
import cheliangxinxi from '@/views/newTMS/publicFiles/wayAndOrder/cheliangxinxi.vue'
import addDizhi from '@/views/newTMS/publicFiles/wayAndOrder/addDizhi.vue'
import addGoodWay from '@/views/newTMS/publicFiles/wayAndOrder/addGoodWay.vue'
import uploadFiles from '@/views/newTMS/publicFiles/uploadFiles.vue'
import guanlianhetong from '@/views/newTMS/publicFiles/wayAndOrder/guanlianhetong.vue'
import zhichu2wayxg from '@/views/newTMS/publicFiles/wayAndOrder/zhichu2wayxg.vue'
import shouruWay from '@/views/newTMS/publicFiles/wayAndOrder/shouruWay.vue'
import shouruWayZB from '@/views/newTMS/publicFiles/wayAndOrder/shouruWayZB.vue'
import uploadImgs from '@/views/newTMS/publicFiles/uploadImgs.vue'
import { getDictionaryDetailList, findCustomerInfoList, updateWay, getWaynfo, pushWayToWHPTFlag } from '@/api/newTMS'
import { selectTMSTenantListByCustom, getDepartmentUsers } from '@/api/newCrm'
import { cVLlist } from '@/api/vgs-driver2.0'
import { compressImages } from '@/utils/compressImages'
export default {
  name: 'addEditWay',
  components: {
    cheliangxinxi, zhichu2wayxg, addDizhi, addGoodWay, uploadFiles, guanlianhetong, shouruWay, uploadImgs, shouruWayZB
  },
  props: {
    editFlag: {
      type: Boolean,
      default: false
    },
    glhwFlag: {
      type: Boolean,
      default: false
    },
    wayBusinessId: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      goodform: {
        goodsList: [],
        measuringUnit: '吨',
        incomePattern: '0',
        makeTicketYn: '是',
        ticketSystemYn: '否',
        revenueValuation: '0'
      },
      rules: {
        projectType: [
          { required: true, message: '请选择项目名称', trigger: 'blur' }
        ],
        payee: [
          { required: true, message: '请选择结算客户', trigger: 'blur' }
        ],
        wayBusinessType: [
          { required: true, message: '请选择业务类型', trigger: 'blur' }
        ],
        productType: [
          { required: true, message: '请选择货物类型', trigger: 'blur' }
        ],
        allWeight: [
          { required: true, message: '请输入货量', trigger: 'blur' }
        ],
        arrivalTime: [
          { required: true, message: '请选择要求到达时间', trigger: 'blur' }
        ],
        payer: [
          { required: true, message: '请输入车队长名称', trigger: 'blur' }
        ],
        payerTaxId: [
          { required: true, message: '请输入身份证号', trigger: 'blur' }
        ],
        businessUserId: [
          { required: true, message: '请选择业务人员', trigger: 'blur' }
        ],
        incomeUnitPrice: [
          { required: true, message: '请输入收入单价', trigger: 'blur' }
        ],
        incomeAmount: [
          { required: true, message: '请输入收入金额', trigger: 'blur' }
        ],
        expenditurePattern: [
          { required: true, message: '请选择支出方式', trigger: 'blur' }
        ],
        freightPricingType: [
          { required: true, message: '请选择运费计价', trigger: 'blur' }
        ],
        freightUnitPrice: [
          { required: true, message: '请输入运费单价', trigger: 'blur' }
        ],
        allFreightAmount: [
          { required: true, message: '请输入运费金额', trigger: 'blur' }
        ],
        serviceRate: [
          { required: true, message: '请输入服务费率', trigger: 'blur' }
        ],
        serviceCharge: [
          { required: true, message: '请输入服务费', trigger: 'blur' }
        ],
        freightTaxRate: [
          { required: true, message: '请输入运费税率', trigger: 'blur' }
        ],
        deliverPerson: [
          { pattern: this.rule.xingming, message: '请输入正确的发货人' }
        ],
        receivingPerson: [
          { pattern: this.rule.xingming, message: '请输入正确的收货人' }
        ],
        taxRate: [
          { required: true, message: '请输入收入税率', trigger: 'blur' }
        ]
      },
      kehuList: [], // 结算客户
      YWLXlist: [], // 业务类型
      fileArr: [],
      GLHTflag: false, // 关联合同
      tWayBusiness: {}, // 运单业务字段
      deleteAttachmentsIds: [],
      yonghuList: [],
      ywyhFlag: false, // 客户身上是否有业务用户
      pickerOptions: {
        disabledDate (time) {
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      elTags: ['需要架子', '需要棉被'],
      tagArr: [],
      CClist: [],
      isZhuanbao: null,
      XMlist: []
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    getDictionaryDetailList({ dictionaryType: 'business_type' }).then(res => { this.YWLXlist = res })
    getDictionaryDetailList({ dictionaryType: 'project_type' }).then(res => { this.XMlist = res })

    cVLlist().then(res => { this.CClist = res })
    getDepartmentUsers({ subOrgCode: localStorage.getItem('orgSubCode'), bussinessUserFlag: 1 }).then(res => { this.yonghuList = res })
    if (this.wayBusinessId) {
      getWaynfo({ wayBusinessId: this.wayBusinessId }).then(res => {
        this.goodform = res.tWay
        if (res.tOrderBusiness) {
          this.isZhuanbao = res.tOrderBusiness.orderSource == 1
        } else {
          this.isZhuanbao = false
        }
        if (this.goodform.pickupTimeStart) {
          this.$set(this.goodform, 'pickupTime', [this.goodform.pickupTimeStart, this.goodform.pickupTimeEnd])
        }
        this.$set(this.goodform, 'kilometres', res.tWay.kilometres ? res.tWay.kilometres.toString() : '0')
        this.$set(this.goodform, 'wayBusinessType', res.tWay.wayBusinessType.toString())
        this.$set(this.goodform, 'payee', res.tWayBusiness.payee)
        this.$set(this.goodform, 'payeeTaxId', res.tWayBusiness.payeeTaxId)
        this.$set(this.goodform, 'payeeCode', res.tWayBusiness.payeeCode)
        this.goodform.deleteWayGoodsRelIds = []
        if (res.tWay.productType) {
          this.$set(this.goodform, 'productType', res.tWay.productType.toString())
        }
        if (res.tWay.licensePlateColor) {
          this.$set(this.goodform, 'licensePlateColor', Number(res.tWay.licensePlateColor))
        }
        this.tWayBusiness = res.tWayBusiness

        // 附件回显
        res.wayAttachmentsList.forEach(item => {
          var filename = item.url.substring(item.url.lastIndexOf('/') + 1)
          this.fileArr.push({ status: 'ready', url: item.fileKeyUrl, id: item.id, name: filename })
        })
        // 收入相关
        this.$set(this.goodform, 'incomePattern', res.tWayBusiness.incomePattern.toString())
        this.$set(this.goodform, 'incomePatternName', res.tWayBusiness.incomePatternName)
        this.$set(this.goodform, 'revenueValuation', res.tWayBusiness.revenueValuation.toString())
        this.$set(this.goodform, 'revenueValuationName', res.tWayBusiness.revenueValuationName)
        this.$set(this.goodform, 'makeTicketYn', res.tWayBusiness.makeTicketYn)
        this.$set(this.goodform, 'ticketSystemYn', res.tWayBusiness.ticketSystemYn)
        if (res.tWayBusiness.incomeUnitPrice) {
          this.$set(this.goodform, 'incomeUnitPrice', res.tWayBusiness.incomeUnitPrice / 100)
        }
        if (res.tWayBusiness.incomeAmount) {
          this.$set(this.goodform, 'incomeAmount', res.tWayBusiness.incomeAmount / 100)
        }

        this.$set(this.goodform, 'payee', res.tWayBusiness.payee)
        this.$set(this.goodform, 'payeeTaxId', res.tWayBusiness.payeeTaxId)
        this.$set(this.goodform, 'payeeCode', res.tWayBusiness.payeeCode)

        // 运力支出相关
        this.$set(this.goodform, 'generalCarrier', res.tWayBusiness.generalCarrier)
        this.$set(this.goodform, 'generalTaxId', res.tWayBusiness.generalTaxId)
        this.$set(this.goodform, 'collectionType', res.tWayBusiness.collectionType)
        this.$set(this.goodform, 'payer', res.tWayBusiness.payer)
        this.$set(this.goodform, 'payerTaxId', res.tWayBusiness.payerTaxId)
        this.$set(this.goodform, 'payerCode', res.tWayBusiness.payerCode)
        if (res.tWayBusiness.expenditurePattern || res.tWayBusiness.expenditurePattern === 0) {
          this.$set(this.goodform, 'expenditurePattern', res.tWayBusiness.expenditurePattern.toString())
          this.$set(this.goodform, 'expenditurePatternName', res.tWayBusiness.expenditurePatternName)
        }
        if (res.tWayBusiness.freightPricingType || res.tWayBusiness.freightPricingType === 0) {
          this.$set(this.goodform, 'freightPricingType', res.tWayBusiness.freightPricingType.toString())
          this.$set(this.goodform, 'freightPricingTypeName', res.tWayBusiness.freightPricingTypeName)
        }
        if (res.tWayBusiness.freightUnitPrice) {
          this.$set(this.goodform, 'freightUnitPrice', res.tWayBusiness.freightUnitPrice / 100)
        }
        if (res.tWayBusiness.freightAmount) {
          this.$set(this.goodform, 'allFreightAmount', res.tWayBusiness.freightAmount / 100)
        }
        this.$set(this.goodform, 'serviceRate', res.tWayBusiness.serviceRate)
        this.$set(this.goodform, 'serviceCharge', res.tWayBusiness.serviceCharge)
        this.$set(this.goodform, 'freightTaxRate', res.tWayBusiness.freightTaxRate)
        this.$set(this.goodform, 'freightRemark', res.tWayBusiness.freightRemark)
        this.$set(this.goodform, 'incomeRemark', res.tWayBusiness.incomeRemark)
        this.$set(this.goodform, 'taxRate', res.tWayBusiness.taxRate)

        // 网货信息
        this.$set(this.goodform, 'onlineFreightFlag', Number(res.tWayBusiness.onlineFreightFlag))
        if (res.tWayBusiness.onlineFreightFlag == 1) {
          pushWayToWHPTFlag().then(res => {
            if (res) {
              this.$set(this.goodform, 'WHJKflag', true)
            } else {
              this.$set(this.goodform, 'WHJKflag', false)
            }
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
              }
            })
          })
        }

        // 货物信息
        this.$set(this.goodform, 'goodsList', res.goodslist)
        this.$set(this.goodform, 'allWeight', res.tWay.dispatchWeight)
        // 判断业务用户是否可选
        findCustomerInfoList({ businessType: 1 }).then(res => {
          selectTMSTenantListByCustom(res).then(res1 => {
            this.kehuList = res1
            let json = this.kehuList.filter(item => item.customerName == this.goodform.payee)
            if (json.length > 0) {
              if (json[0].businessUserCode) {
                this.ywyhFlag = true
              } else {
                this.ywyhFlag = false
              }
            }
          })
        })
        // 运输类型回显
        this.$set(this.goodform, 'transportMode', this.goodform.transportMode ? this.goodform.transportMode : 1)
        if (this.goodform.transportMode == 2) {
          this.$set(this.goodform, 'activeName', 'second')
        } else {
          this.$set(this.goodform, 'activeName', 'first')
        }
        // 根据货物类型判断吨件方必填 换了一个方法
        // getDictionaryDetailList({ dictionaryType: 'goods_type' }).then(res => {
        //   // this.HWlist = res
        //   let json = res.filter(item => item.itemNo == this.goodform.productType)
        //   this.$set(this.goodform, 'dun', json[0].ext1)
        //   this.$set(this.goodform, 'jian', json[0].ext2)
        //   this.$set(this.goodform, 'fang', json[0].ext3)
        // })
      })
    }
  },
  methods: {
    tagClick (item) {
      this.tagArr.push(item)
      this.tagArr = Array.from(new Set(this.tagArr))
      this.$set(this.goodform, 'remark', this.tagArr.toString())
    },
    remarkFn () {
      if (!this.goodform.remark) {
        this.tagArr = []
      }
    },
    // 选择用户
    yonghuChange (e) {
      let json = this.yonghuList.filter(item => item.userCode == e)
      this.$set(this.goodform, 'businessUser', json[0].userName)
    },
    // 删除文件
    remove (file) {
      if (file.id) {
        this.deleteAttachmentsIds.push(file.id)
      }
    },
    saveFn () {
      const newArr = this.goodform.goodsList.map(item => item.cargoBarcode)
      const arrSet = new Set(newArr)
      if (arrSet.size !== newArr.length) {
        this.$alert('捆包号不能重复', '系统提示')
        return
      }
      if (!this.goodform.kilometres) {
        this.$alert('公里数不能为空，请联系系统管理员', '系统提示')
        return
      }
      if (!this.goodform.allWeight) {
        this.$alert('运单量不能为0', '系统提示')
        return
      }

      if (this.goodform.WHJKflag) {
        if (!this.goodform.idNumber) {
          this.$alert('请选择司机', '系统提示')
          return false
        }
        if (!this.goodform.plateNumber) {
          this.$alert('请选择车辆', '系统提示')
          return false
        }
      } else {
        if (this.goodform.transportMode == 1) {
          if (!this.goodform.deliverAddressId) {
            this.$alert('请选择发货地址', '系统提示')
            return
          }
          if (!this.goodform.receivingAddressId) {
            this.$alert('请选择收货地址', '系统提示')
            return
          }
          if (this.goodform.wayState === 0) {
            if (!this.goodform.idNumber) {
              this.$alert('请选择司机', '系统提示')
              return false
            }
            if (!this.goodform.plateNumber) {
              this.$alert('请选择车辆', '系统提示')
              return false
            }
          } else {
            if (!this.goodform.idNumber) {
              this.$alert('请选择司机', '系统提示')
              return false
            }
            if (!this.goodform.plateNumber) {
              this.$alert('请选择车辆', '系统提示')
              return false
            }
          }
        }
      }
      console.log('this.goodform.wayState', this.goodform.wayState)
      if (this.goodform.plateNumber && this.goodform.wayState === 0) { // 根据有没用车牌号来判断是待配载还是待装车
        this.$set(this.goodform, 'wayState', 1)
      }
      this.$refs.goodform.validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: '正在处理...'
          })
          if (this.goodform.pickupTime) {
            this.goodform.pickupTimeStart = this.goodform.pickupTime[0]
            this.goodform.pickupTimeEnd = this.goodform.pickupTime[1]
          }
          let json = this.kehuList.filter(item => item.customerName == this.goodform.payee)
          if (json.length > 0) {
            this.goodform.payeeTaxId = json[0].customerTaxId
            this.goodform.payeeCode = json[0].tenantCode
          }
          let yewuleixingJson = this.YWLXlist.filter(item => item.itemNo == this.goodform.wayBusinessType)
          if (yewuleixingJson.length > 0) {
            this.goodform.wayBusinessTypeName = yewuleixingJson[0].showName
          }

          if (this.goodform.collectionType == 2) { // 司机
            this.$set(this.goodform, 'payer', this.goodform.driverName)
            this.$set(this.goodform, 'payerTaxId', this.goodform.idNumber)
            this.goodform.payerCode = ''
          }
          // 赋值调度量
          this.$set(this.goodform, 'dispatchWeight', this.goodform.allWeight)
          // 运费总额赋值
          this.$set(this.goodform, 'freightAmount', this.goodform.allFreightAmount)

          // 组装数据
          let data = {}
          data.tWay = this.goodform

          data.goodslist = []// 修改只传新加的值
          this.goodform.goodsList.forEach(item => {
            if (!item.wayGoodsRelId) {
              data.goodslist.push(item)
            }
          })
          data.deleteWayGoodsRelIds = this.goodform.deleteWayGoodsRelIds
          data.deleteAttachmentsIds = this.deleteAttachmentsIds

          data.payeeCode = this.goodform.settlementCustomersCode
          data.payerCode = this.goodform.generalCode
          console.log(this.goodform)
          data.tWayBusiness = this.tWayBusiness// 把业务实体整个赋值
          // 收入相关
          data.tWayBusiness.payee = this.goodform.payee
          data.tWayBusiness.payeeTaxId = this.goodform.payeeTaxId
          data.tWayBusiness.payeeCode = this.goodform.payeeCode
          data.tWayBusiness.incomePattern = this.goodform.incomePattern
          data.tWayBusiness.revenueValuation = this.goodform.revenueValuation
          data.tWayBusiness.incomePatternName = this.goodform.incomePatternName
          data.tWayBusiness.revenueValuationName = this.goodform.revenueValuationName
          data.tWayBusiness.makeTicketYn = this.goodform.makeTicketYn
          data.tWayBusiness.ticketSystemYn = this.goodform.ticketSystemYn
          data.tWayBusiness.incomeUnitPrice = this.goodform.incomeUnitPrice
          data.tWayBusiness.incomeAmount = this.goodform.incomeAmount
          data.tWayBusiness.generalCarrier = this.goodform.generalCarrier
          data.tWayBusiness.generalTaxId = this.goodform.generalTaxId
          data.tWayBusiness.collectionType = this.goodform.collectionType
          data.tWayBusiness.payer = this.goodform.payer
          data.tWayBusiness.payerTaxId = this.goodform.payerTaxId
          data.tWayBusiness.payerCode = this.goodform.payerCode
          data.tWayBusiness.expenditurePattern = this.goodform.expenditurePattern
          data.tWayBusiness.freightPricingType = this.goodform.freightPricingType
          data.tWayBusiness.expenditurePatternName = this.goodform.expenditurePatternName
          data.tWayBusiness.freightPricingTypeName = this.goodform.freightPricingTypeName
          data.tWayBusiness.freightUnitPrice = this.goodform.freightUnitPrice
          data.tWayBusiness.freightAmount = this.goodform.freightAmount
          data.tWayBusiness.serviceRate = this.goodform.serviceRate
          data.tWayBusiness.serviceCharge = this.goodform.serviceCharge
          data.tWayBusiness.freightTaxRate = this.goodform.freightTaxRate
          data.tWayBusiness.onlineFreightFlag = this.goodform.onlineFreightFlag
          data.tWayBusiness.freightRemark = this.goodform.freightRemark
          data.tWayBusiness.incomeRemark = this.goodform.incomeRemark
          data.tWayBusiness.taxRate = this.goodform.taxRate

          let imgfile = new FormData()
          imgfile.append('params', JSON.stringify(data))
          this.fileArr.forEach(item => {
            if (!item.id) {
              imgfile.append('files', item.raw)
            }
          })
          updateWay(imgfile).then(res => {
            loading.close()
            this.$emit('update:editFlag', false)
            this.$parent.searchFn()
          }).catch(error => {
            this.$message({
              showClose: true,
              message: error.message,
              type: 'error',
              onClose () {
                loading.close()
              }
            })
          })
        }
      })
    },
    // 运单状态改变
    wayStateChange (e) {
      if (e == 1) {
        this.$set(this.goodform, 'truckload', '')
        this.$set(this.goodform, 'actualLoadingTime', '')
        this.ZCimgList = []
        this.$set(this.goodform, 'unloadings', '')
        this.$set(this.goodform, 'actualUnloadingTime', '')
        this.XCimgList = []
        this.$set(this.goodform, 'receiptRequest', '')
        this.$set(this.goodform, 'signRemark', '')
        this.$set(this.goodform, 'actualSigningTime', '')
        this.$set(this.goodform, 'liquidatedAmount', '')
        this.QSimgList = []
      } else if (e == 2) {
        this.$set(this.goodform, 'unloadings', '')
        this.$set(this.goodform, 'actualUnloadingTime', '')
        this.XCimgList = []
        this.$set(this.goodform, 'receiptRequest', '')
        this.$set(this.goodform, 'signRemark', '')
        this.$set(this.goodform, 'actualSigningTime', '')
        this.$set(this.goodform, 'liquidatedAmount', '')
        this.QSimgList = []
      } else if (e == 3) {
        this.$set(this.goodform, 'receiptRequest', '')
        this.$set(this.goodform, 'signRemark', '')
        this.$set(this.goodform, 'actualSigningTime', '')
        this.$set(this.goodform, 'liquidatedAmount', '')
        this.QSimgList = []
      } else if (e == 4) {
        this.$set(this.goodform, 'receiptRequest', '正常签收')
      }
    },
    // 选择结算客户
    jiesuanChange () {
      let json = this.kehuList.filter(item => item.customerName == this.goodform.payee)
      this.goodform.payCustomerId = json[0].id
      this.goodform.payeeTaxId = json[0].customerTaxId
      this.goodform.payeeCode = json[0].tenantCode
      this.goodform.salesContract = ''
      this.goodform.periodDays = json[0].periodDays
      this.goodform.periodDaysType = json[0].periodDaysType
      if (json[0].businessUserCode) {
        this.ywyhFlag = true
        this.$set(this.goodform, 'businessUserId', json[0].businessUserCode)
        this.$set(this.goodform, 'businessUser', json[0].businessUserName)
      } else {
        this.ywyhFlag = false
        this.$set(this.goodform, 'businessUserId', null)
        this.$set(this.goodform, 'businessUser', null)
      }
      this.goodform.originalCustomer = this.goodform.payee// 下单客户
    },
    xuanzeHT () {
      this.GLHTflag = true
    },
    delGoodFn () {
    },
    closeDialog () {
      this.$emit('update:editFlag', false)
    }

  },
  destroyed () {

  }
}
</script>

<style scoped lang='less'>
/deep/.remark .el-input .el-input__inner{
  width: 800px;
  height: 80px;
}
/deep/.el-form-item--mini.table_error {
  margin-bottom: 0 !important;
  margin: 14px 0 !important;
}
.disabled /deep/.el-input__inner {
    background: #eff0f1;
}
.width1  /deep/.el-input__inner{
  width:100px;
}
.danweiBox{
  /deep/.el-input{
    width: auto;
  }
  /deep/.el-select{
    width: 60px;
    .el-input__inner{
    width: 60px;
  }
  }
}
.imgBox{
  margin: 0px 15px  10px;
}
/deep/.el-range-editor{
  width: 430px;
}
</style>
